import { render, staticRenderFns } from "./AccomTabsReservations.vue?vue&type=template&id=2e72565f&scoped=true&"
import script from "./AccomTabsReservations.vue?vue&type=script&lang=js&"
export * from "./AccomTabsReservations.vue?vue&type=script&lang=js&"
import style0 from "./AccomTabsReservations.vue?vue&type=style&index=0&id=2e72565f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72565f",
  null
  
)

export default component.exports